import { type ReactNode } from "react";
import { Result } from "antd";
import type { Agent } from "./domain";
import { businessLabels, hasBusinessAccess, type Business } from "./business";

/** Use the principal loaded by the session shell; APIs enforce current authorization. */
export function BusinessAccess({ agent, business, children }: {
  agent: Agent; business: Business; children: ReactNode;
}) {
  if (!hasBusinessAccess(agent, business)) return <Result status="403" title={`${businessLabels[business]}权限未开通`} subTitle="请联系平台管理员开通该业务权限。" />;
  return children;
}
